import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Home from "./pages/Home";
import Order from "./pages/Order"; // <-- your new page
import OrderSummary from "./pages/OrderSummary"; // <-- your new page
import { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CssBaseline } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./i18n";
import "./styles/design-system.css";

// Create RTL cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

function App() {
  const { i18n } = useTranslation();

  const theme = createTheme({
    direction: i18n.dir(),
    palette: {
      primary: { main: "#1b7a3d", dark: "#0f4d28", light: "#2f9e5b" },
      secondary: { main: "#2f9e5b" },
      success: { main: "#1b7a3d" },
      background: { default: "#f3faf5", paper: "#ffffff" },
      text: { primary: "#14201a", secondary: "#5a6b62" },
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily:
        i18n.language === "he"
          ? '"Assistant", "Rubik", sans-serif'
          : i18n.language === "ar"
            ? '"Tajawal", Poppins, sans-serif'
            : '"Poppins", "Tajawal", sans-serif',
      button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            backgroundColor: "#1b7a3d",
            "&:hover": { backgroundColor: "#0f4d28" },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 18,
            overflow: "hidden",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            backgroundColor: "#fff",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: { borderRadius: 16 },
        },
      },
    },
  });

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <link href="https://fonts.googleapis.com/css2?family=Assistant:wght@200;300;400;500;600;700;800&family=Rubik:wght@300;400;500;600;700&family=Tajawal:wght@200;300;400;500;700;800;900&display=swap" rel="stylesheet"></link>
        <CartProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Order" element={<Order />} />
              <Route path="/OrderSummary" element={<OrderSummary />} />
            </Routes>
          </Router>
        </CartProvider>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;